// extracted by mini-css-extract-plugin
export default {"Container":"IntroWrapper_Container__VN2RD","ContentContainer":"IntroWrapper_ContentContainer__bnWTl","ImageBox":"IntroWrapper_ImageBox__r-Qah"};